import { render } from "./ModalAddProject.vue?vue&type=template&id=65071d2e&scoped=true"
import script from "./ModalAddProject.vue?vue&type=script&lang=js"
export * from "./ModalAddProject.vue?vue&type=script&lang=js"

import "./ModalAddProject.vue?vue&type=style&index=0&id=65071d2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65071d2e"]])

export default __exports__